import { __read } from "tslib";
export function extractDataAttributes(props) {
    return Object.entries(props).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        if (/^data-(.*)/.test(key)) {
            acc.dataAttributes[key] = val;
        }
        else {
            acc.restProps[key] = val;
        }
        return acc;
    }, {
        dataAttributes: {},
        restProps: {},
    });
}
//# sourceMappingURL=extractDataAttributes.js.map